/**
 * Grabs whether dating mocking is enabled in local storage.
 * That means if the string 'true' is in the mockDataEnabled key.
 * @returns boolean - whether mock data enabled is true
 */
const getLocalMockDataEnabled = (): boolean =>
  localStorage.getItem('mockDataEnabled') === 'true'

export default getLocalMockDataEnabled
